import { render, staticRenderFns } from "./loan_detail.vue?vue&type=template&id=267c88b6"
import script from "./loan_detail.vue?vue&type=script&lang=js"
export * from "./loan_detail.vue?vue&type=script&lang=js"
import style0 from "./loan_detail.vue?vue&type=style&index=0&id=267c88b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports